export const WEBLATE_COMPONENT_NAME = 'common/uikit';
